import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import * as moment from 'moment-jalaali';
import axios from 'src/app/Service/axios';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-net-consumed',
  templateUrl: './net-consumed.component.html',
  styleUrls: ['./net-consumed.component.css']
})

export class NetConsumedComponent implements OnInit {
  total_RealConsumption = 0;
  total_TotalHarvesting = 0;
  total_TotalRefueling = 0;
  lst_Result: any = [];
  lst_Search: any = [];
  
  mdl_Search: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    strSDate: new FormControl(moment().format('jYYYY/jMM/01')),

    strEDate: new FormControl(''),

  });

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private route: ActivatedRoute,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

  ) { }

  ngOnInit(): void {

  }

  async search_Result() {

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`Fueltank_CarsNetConsumed`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'x110' } });

      return;

    }

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_Result = res;

    this.lst_Search = res;

    this.calculateTotals()

  }

  filter_list(val: any) {

    this.calculateTotals()

    this.lst_Result = this.lst_Search.filter((el: any) => {

      return el?.strFullName?.includes(val.value) ||

        el.strMobileType_strComment?.toString().includes(val.value) ||

        el.strMobileGroup_strComment?.toString().includes(val.value) ||

        el.strMobileDomain_strComment?.includes(val.value) ||

        el.strGPSType_strComment?.includes(val.value) ||

        el.strMobile?.includes(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_Result = this.lst_Search;

    }

  }

  highlightText(text: string, searchTerm: string) {

    if (!searchTerm) {

      return text;

    }

    const regex = new RegExp(searchTerm, 'gi');

    return text?.replace(regex, (match: string) => {

      return `<mark>${match}</mark>`;

    });

  }

  calculateTotals() {

    this.total_RealConsumption = 0;

    this.total_TotalHarvesting = 0;

    this.total_TotalRefueling = 0;

    for (const item of this.lst_Result) {

      this.total_RealConsumption += parseFloat(item.RealConsumption || 0);

      this.total_TotalHarvesting += parseFloat(item.TotalHarvesting || 0);

      this.total_TotalRefueling += parseFloat(item.TotalRefueling || 0);

    }

  }

  exportExcel(id: any): void {
    /* pass here the table id */
    let element = document.getElementById(`${id}`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'سوخت خالص مصرفی خودروها.xlsx');
  }

}
